import {z} from 'zod'

// --- Recipient filter types ---

export const MailerFilterField = z.object({
    key: z.string(),
    operator: z.string(),
    value: z.unknown()
})
export type MailerFilterField = z.infer<typeof MailerFilterField>

export const MailerFilters = z.object({
    operator: z.literal('and'),
    fields: z.array(MailerFilterField)
})
export type MailerFilters = z.infer<typeof MailerFilters>

// --- Form validation schema ---

export const MailerFormValidationSchema = z
    .object({
        subject: z.string().min(1, "L'oggetto è obbligatorio").max(200, "L'oggetto non può superare i 200 caratteri"),
        body: z.string().min(1, 'Il corpo del messaggio è obbligatorio'),
        includePatients: z.boolean(),
        includeConsultants: z.boolean(),
        // Patient filters
        patientMinAge: z.coerce.number().min(0).optional(),
        patientMaxAge: z.coerce.number().min(0).optional(),
        patientGender: z.enum(['male', 'female']).optional(),
        patientResidenceAslDistrictId: z.string().optional(),
        patientOutsideRegion: z.boolean().optional(),
        patientNeuromuscularDiagnosisId: z.string().optional(),
        patientServiceType: z.enum(['adults', 'evolutionary_age', 'evolutionary_age_adults']).optional(),
        // Consultant filters
        consultantSpecializationId: z.string().optional(),
        consultantStatus: z.enum(['operative', 'candidate', 'suspended', 'absent', 'terminated']).optional(),
        consultantContractType: z.enum(['consultant', 'flat_rate', 'employee']).optional(),
        consultantWorkSector: z.enum(['domiciliary', 'outpatient', 'outpatient_domiciliary']).optional()
    })
    .refine(data => data.includePatients || data.includeConsultants, {
        path: ['includePatients'],
        message: 'Seleziona almeno un tipo di destinatario'
    })
export type MailerFormValidationSchema = z.infer<typeof MailerFormValidationSchema>

// --- API request/response types ---

export const SendMailPayload = z.object({
    subject: z.string().min(1),
    body: z.string().min(1),
    recipients: z.object({
        patients: z
            .object({
                filters: MailerFilters.optional()
            })
            .optional(),
        consultants: z
            .object({
                filters: MailerFilters.optional()
            })
            .optional()
    })
})
export type SendMailPayload = z.infer<typeof SendMailPayload>

export const PreviewRecipient = z.object({
    id: z.string(),
    fullName: z.string(),
    email: z.string()
})
export type PreviewRecipient = z.infer<typeof PreviewRecipient>

export const SendMailResponse = z.object({
    recipientCount: z.number()
})
export type SendMailResponse = z.infer<typeof SendMailResponse>
